import { render, staticRenderFns } from "./AddDebitorContactEventDlg.vue?vue&type=template&id=be459058&"
import script from "./AddDebitorContactEventDlg.vue?vue&type=script&lang=js&"
export * from "./AddDebitorContactEventDlg.vue?vue&type=script&lang=js&"
import style0 from "./AddDebitorContactEventDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports